export const BUDGET = (value) =>({type: "budget", payload: value})
export const NAME = (value) =>({type: "name", payload: value})